import users from './user';
import positions from './position';
import departments from './department';
import freelancers from './freelancer';
import roles from './role';
import feed from './feed.json';
import settings from './settings.json';

export default {
  ...users,
  ...positions,
  ...departments,
  ...freelancers,
  ...roles,
  ...feed,
  ...settings,
};
